import { Injectable } from '@angular/core';
import { environment } from '@app-environments/environment';
import { ApiRequest } from '../api.request';
import {
  BaseGetCollectionResponse,
  BaseGetSearchCountByIdRequest,
  BaseResponse,
} from '@app-types/base/base';
import {
  GetSearchCounter,
  Group,
  GroupCreateUpdateRequest,
  GroupDeleteRequest,
} from '@app-types/api/group';
import { API_ROUTES } from '@app-shared/constants/routes/api.routes';
import { BaseCollectionFilteredSearchByIdRequest } from '@app-types/common';
import { GroupSearchOrder } from '@app-types/enums/GroupSearchOrder';
import { FileRefContract } from '@app-types/api/file';

const API_URL = environment.apiUrl;
const { groupSettings } = API_ROUTES;
const { getForOrganization, create, update, getSearchCounter, exportExcel } =
  groupSettings;

@Injectable({
  providedIn: 'root',
})
export class GroupClient {
  constructor(private apiClient: ApiRequest) {}

  public async getAllByOrganization(
    request: BaseCollectionFilteredSearchByIdRequest<GroupSearchOrder>
  ): Promise<BaseGetCollectionResponse<Group>> {
    return this.apiClient.post(request, `${API_URL}${getForOrganization}`);
  }

  // async exportExcel(
  //   request: BaseCollectionFilteredSearchByIdRequest<GroupSearchOrder>
  // ): Promise<BaseResponse<FileRefContract>> {
  //   return this.apiClient.post(request, `${API_URL}${exportExcel}`);
  // }

  async exportExcel(): Promise<BaseResponse<FileRefContract>> {
    return this.apiClient.get(`${API_URL}${exportExcel}`);
  }

  public async create(request: GroupCreateUpdateRequest): Promise<void> {
    return this.apiClient.post<GroupCreateUpdateRequest, any>(
      request,
      `${API_URL}${create}`
    );
  }

  public async update(request: GroupCreateUpdateRequest): Promise<void> {
    return this.apiClient.post<GroupCreateUpdateRequest, any>(
      request,
      `${API_URL}${update}`
    );
  }

  public async delete(request: GroupDeleteRequest): Promise<void> {
    return this.apiClient.post<GroupDeleteRequest, any>(
      request,
      `${API_URL}${groupSettings.delete}`
    );
  }

  public async getSearchCounter(
    request: BaseGetSearchCountByIdRequest
  ): Promise<GetSearchCounter> {
    return this.apiClient.get<GetSearchCounter>(
      `${API_URL}${getSearchCounter}?${request.format()}`
    );
  }
}
